import _extends from "@babel/runtime/helpers/extends";

/*
 * @Author: wangshengqiang
 * @Date: 2021-04-22 14:23:24
 * @LastEditTime: 2021-04-22 15:54:34
 * @LastEditors: wangshengqiang
 * @Description: s
 */
import React from 'react';
export default function a(Component, extraProps) {
  function withProps(props) {
    return /*#__PURE__*/React.createElement(Component, _extends({}, extraProps, props));
  }

  withProps._name = Component.name;
  return withProps;
}